import EtablissementPoleEmploiIdentifiant from '@/generated/controls/etablissement/EtablissementPoleEmploiIdentifiant.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementPoleEmploiIdentifiant
})
